import type { FaireProductEntity } from "../../entity_types/product";

export const p_vy4x7g95a2: FaireProductEntity = {
  token: "p_vy4x7g95a2",
  type: "product",
  name: "Harvest Wreath 2-in-1 Fall Decor Building Kit",
  brandToken: "b_u6s27vxprc",
  brandName: "Brickcraft",
  imageUrl:
    "https://cdn.faire.com/fastly/fd2dafa4c88d5afa198aefa6880c99ff0913b3801d7cdbe9deedd84c20830a44.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b0f5c6cdd470051beef0ee8301eaa9ba0e7f6d555326fd1b747789f3620cfb8a.jpeg",
    "https://cdn.faire.com/fastly/ac48fa0dd537f42d8ea1b55b793322475767127160dd76ff7d78259222e40455.jpeg",
    "https://cdn.faire.com/fastly/77539160a4cfac8a2d22e1b27f64e2b7b614ff208371eea319ede3c3b9ca5553.jpeg",
    "https://cdn.faire.com/fastly/ec4fa1a9e0e4b384cbfc7068643a2ad18ea4c183d75abe3dedf322a5ad8e5722.jpeg",
    "https://cdn.faire.com/fastly/0330828eb62c814a19dafe8af9cca9681aa1209e5a303a54af9095b82a7ee426.jpeg",
    "https://cdn.faire.com/fastly/2a3a56bba7dfed467b1b376b53f99196ea063e648b3bc2f68006666b82b9ab9e.jpeg",
    "https://cdn.faire.com/fastly/22f918c62da93c8530da34fd6ea0e59c9e407ecf1e872dc0b96bf36e7e370d5b.jpeg",
  ],
  priceDollars: 15.16,
  description:
    "This cozy 2-in-1 build features an autumn-inspired wreath that can be rebuilt into a festive garland. With acorns, berries, sunflowers, and colorful leaves, it’s a charming seasonal display for any space. A printed “It’s Fall Y’all” sign and included string make it easy to hang or showcase on a table, shelf, or mantle - no watering required.",
  tags: [],
  msrpDollars: 30.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:37.854Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
